import { useState } from "react";
import { HiChevronDown } from "react-icons/hi";
import {
  CardRoot,
  CoverImage,
  Description,
  ExpandDetails,
  IdBadge,
  InfoPanel,
  PriceBlock,
  ToggleButton,
  UnitBlock,
} from "./styles";

const PLACEHOLDER_IMG = "/images/placeholder-image-nogueira.png";

export interface PropertyCardData {
  id: number;
  idDisplay?: string;
  bairro?: string;
  cidade?: string;
  descricao?: string;
  enderecoCompleto?: string;
  valorVenda?: number;
  apBloco?: string;
  apNumero?: string | number;
  imageUrl?: string;
  isEmpreendimento?: boolean;
}

function formatBRL(value?: number) {
  if (value == null || Number.isNaN(Number(value))) {
    return "Sob consulta";
  }

  return Number(value).toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

function buildLocationLabel(data: PropertyCardData) {
  const place = [data.bairro, data.cidade].filter(Boolean).join(", ");
  if (data.idDisplay && place) return { id: data.idDisplay, place };
  if (data.idDisplay) return { id: data.idDisplay, place: "" };
  return { id: "", place };
}

function buildDescription(data: PropertyCardData) {
  return [data.descricao, data.enderecoCompleto].filter(Boolean).join(" ");
}

function buildPropertyUrl(data: PropertyCardData) {
  return data.isEmpreendimento
    ? `/empreendimento/${data.id}`
    : `/imovel/${data.id}`;
}

export function PropertyCardCarousel(props: PropertyCardData) {
  const [opened, setOpened] = useState(false);

  const { id, place } = buildLocationLabel(props);
  const description = buildDescription(props);
  const imageSrc = props.imageUrl || PLACEHOLDER_IMG;

  const handleNavigate = () => {
    window.open(buildPropertyUrl(props), "_blank", "noopener,noreferrer");
  };

  return (
    <CardRoot
      onMouseEnter={() => setOpened(true)}
      onMouseLeave={() => setOpened(false)}
    >
      <IdBadge>
        {id ? (
          <b>
            {id}
            {place ? " - " : ""}
          </b>
        ) : null}
        {place}
      </IdBadge>

      <CoverImage
        src={imageSrc}
        alt="Imagem do imóvel"
        onClick={handleNavigate}
        onError={(e) => {
          e.currentTarget.src = PLACEHOLDER_IMG;
        }}
      />

      <InfoPanel>
        <Description title={description || undefined}>
          {description}
        </Description>

        <ExpandDetails $open={opened}>
          <div className="expand-inner">
            <PriceBlock>
              <p>A partir de:</p>
              <div>
                <b>{formatBRL(props.valorVenda)}</b> *
              </div>
              <p className="disclaimer">* Sujeito a disponibilidade</p>
            </PriceBlock>
            <UnitBlock>
              {props.apBloco != null && props.apBloco !== "" && (
                <p>Bloco: {props.apBloco}</p>
              )}
              {props.apNumero != null && props.apNumero !== "" && (
                <p>Unidade: {props.apNumero}</p>
              )}
            </UnitBlock>
          </div>
        </ExpandDetails>

        <ToggleButton
          type="button"
          $open={opened}
          aria-expanded={opened}
          aria-label={opened ? "Recolher detalhes" : "Expandir detalhes"}
          onClick={(e) => {
            e.stopPropagation();
            setOpened((prev) => !prev);
          }}
        >
          <HiChevronDown size={18} />
        </ToggleButton>
      </InfoPanel>
    </CardRoot>
  );
}
